import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

const VerifyIdLink = ({ isSmallScreen }: Props) => {
	return (
		<StyledText isSmallScreen={isSmallScreen}>
			Please verify your mobile phone number and ID first on the{' '}
			<NavLink to="/account/profile" title="Profile" className="_text-secondary">
				Profile
			</NavLink>{' '}
			page.
		</StyledText>
	);
};

export default VerifyIdLink;

interface Props {
	isSmallScreen: boolean;
}

const StyledText = styled.p<{ isSmallScreen: boolean }>`
	text-align: center;
	margin-bottom: ${({ isSmallScreen }) => (isSmallScreen ? '20px' : '30px')};
	font-size: ${({ isSmallScreen }) => (isSmallScreen ? '14px' : '18px')};
`;
